import useStore from 'hooks/useStore';
import React from 'react';
import styled from 'styled-components';
import { getCollapsibleSidebarWidth } from '../func';

const OuterContainer = ({ children }) => {
  const { state } = useStore();
  const { isMenuExpand } = state;

  return (
    <OuterContainerStyled $isMenuExpand={isMenuExpand}>
      {children}
    </OuterContainerStyled>
  );
};

const OuterContainerStyled = styled.div`
  flex-grow: 1;
  transition: margin-left 0.3s;
  height: fit-content;
  margin-left: ${(props) => getCollapsibleSidebarWidth(props?.$isMenuExpand)};
`;

export default OuterContainer;
